module.exports = __webpack_public_path__ + "static/media/pet-card.8c9d77f0.svg";